// src/calculators/prefill.js — мост между калкулатори (задача 4/6).
//
// „Наем" подава тримесечие/година на декларацията по чл. 55 (задача 5/6):
// бутонът „Към декларацията по чл. 55" оставя стойностите тук, а панелът на
// чл. 55 ги ВЗЕМА еднократно при следващото си отваряне (take изчиства —
// старият предпопълнен избор не бива да изскача при по-късно отваряне).

let _chl55 = null;

export function setChl55Prefill(v) { _chl55 = v || null; }
export function takeChl55Prefill() { const v = _chl55; _chl55 = null; return v; }

// „Авансови ЗКПО" → „Промяна на авансовите вноски" (ПРОМТ-22): годишният
// данък { annualTax }; досегашната вноска се дели според вида (÷ 4 или ÷ 12).
let _zkpoChange = null;
export function setZkpoChangePrefill(v) { _zkpoChange = v || null; }
export function takeZkpoChangePrefill() { const v = _zkpoChange; _zkpoChange = null; return v; }
//
// „Граждански договор" (ПРОМТ-21) подава освен тримесечие/година и готов ред
// `row` (чл. 43: брутно, вид дейност, удържани осигуровки) — чл. 55 го показва
// предварително попълнен вместо празния ред за наем.
